  $(".common-faq-section .faq-block").find(".title-block").click(function () {
    $(this).next().toggleClass("open").slideToggle("fast");
    $(this).toggleClass("active-tab").find(".content-link").toggleClass("active");
    $(".accordion-content").not($(this).next()).slideUp("fast").removeClass("open");
    $(".title-block").not($(this)).removeClass("active-tab").find("content-link")
    .removeClass("active");
  });


 
  $('.menu-drawer__menu .list-menu__item').click(function () {
 
  if ($(".menu-drawer-container ").hasClass("menu-opening")) {
    
    $(".menu-drawer-container ").removeClass("menu-opening");
    $(".header__icon--summary").attr('aria-expanded', 'false');

     $("body").removeClass("overflow-hidden-tablet");
    
  }
});

 $(document).ready(function () {
    $('a[href^="#"]').on('click', function (event) {
        event.preventDefault();
        var target = $(this).attr('href');
        var $target = $(target);
        if ($target.length) {
            $('html, body').stop().animate({
                scrollTop: $target.offset().top - 100
            }, 900, 'swing', function () {
                window.location.hash = target;
            });
        }
    });
});



 var players = []
  $('.iframe-video-cover').each(function() {
      players.push({
          player: new Vimeo.Player($(this).find("iframe").get(0)),
          top: $(this).position().top,
          status: "paused"
      })
  });
  var viewportHeight = $(window).height();
  
  $(window).on('scroll', function() {
      var scrollPos = $(window).scrollTop();
      for (var i = 0; i < players.length; i++) {
          var elementFromTop = players[i].top - scrollPos;
          var status = (elementFromTop > 0 && elementFromTop < players[i].top + viewportHeight) ? "play" : "pause";
          if (players[i].status != status) {
              players[i].status = status;
              players[i].player[status]();
              console.log(i, status);
          }
      }
  });

